/* Draft inspection only. Published languages keep Shopify's native POST flow. */
(function () {
  'use strict';
  if (window.__stridesPreviewLanguages) {
    window.__stridesPreviewLanguages.refresh();
    return;
  }

  var draftId = '194249163098';
  var targets = [
    ['da', 'Dansk'], ['pl', 'Polski'], ['cs', 'Čeština'], ['es', 'Español'],
    ['pt-PT', 'Português (Portugal)']
  ];
  var localePrefixes = /^(en|de|fr|it|nl|da|pl|cs|es|pt|pt-pt)$/i;

  function isDraft() {
    var theme = window.Shopify && window.Shopify.theme;
    return !!theme && String(theme.id) === draftId && theme.role === 'unpublished';
  }

  function previewUrl(locale) {
    if (!isDraft() || !targets.some(function (entry) { return entry[0] === locale; })) return null;
    var url = new URL(window.location.href);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    var parts = url.pathname.split('/');
    // Strip only known leading language segments; preserve handles and deeper path segments.
    while (parts.length > 1 && localePrefixes.test(parts[1])) parts.splice(1, 1);
    // Shopify locale identity is pt-PT; its verified domain root is /pt/.
    var prefix = locale === 'pt-PT' ? 'pt' : locale;
    url.pathname = '/' + prefix + (parts.join('/') || '/');
    // isDraft() confirms this page is already served in the target preview session.
    // Re-initializing preview redirects and collapses repeated filter query keys.
    // These are same-session links, not shareable preview/bootstrap URLs.
    url.searchParams.delete('preview_theme_id');
    return url.href;
  }

  function updateLinks(group) {
    group.querySelectorAll('[data-strides-preview-language]').forEach(function (link) {
      var url = previewUrl(link.getAttribute('data-strides-preview-language'));
      if (url) link.href = url;
      else link.removeAttribute('href');
    });
  }

  function refresh() {
    document.querySelectorAll('[data-strides-preview-languages]').forEach(function (group) {
      // Both real served metadata fields are mandatory; URL/editor flags never grant access.
      if (!isDraft()) {
        group.hidden = true;
        group.replaceChildren();
        return;
      }
      if (!group.childElementCount) {
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', 'Entwurfs-Vorschau');
        group.setAttribute('lang', 'de');
        group.style.cssText = 'margin-block-start:1rem;padding-block-start:1rem;border-top:1px solid rgb(var(--border-color));';
        // Leave room to scroll the last preview link above Shopify's mobile toolbar.
        var clearance = document.createElement('style');
        clearance.textContent = '@media screen and (max-width: 999px) { [data-strides-preview-languages] { padding-block-end: calc(80px + env(safe-area-inset-bottom, 0px)); } }';
        group.appendChild(clearance);
        var heading = document.createElement('p');
        heading.textContent = 'Entwurfs-Vorschau';
        heading.style.cssText = 'font-weight:600;margin-block-end:.5rem;';
        group.appendChild(heading);
        var note = document.createElement('p');
        note.textContent = 'Übersetzung in Arbeit · nur mit Vorschau-Zugriff';
        note.style.cssText = 'font-size:.75rem;line-height:1.4;margin-block-end:.75rem;';
        group.appendChild(note);
        var links = document.createElement('div');
        links.className = 'popover__value-list';
        targets.forEach(function (entry) {
          var link = document.createElement('a');
          link.setAttribute('data-strides-preview-language', entry[0]);
          link.setAttribute('lang', entry[0]);
          link.setAttribute('hreflang', entry[0]);
          link.textContent = entry[1] + ' — Vorschau';
          links.appendChild(link);
        });
        group.appendChild(links);
        group.addEventListener('click', function (event) {
          var link = event.target.closest && event.target.closest('[data-strides-preview-language]');
          if (!link) return;
          // Recheck immediately before navigation, including pages restored from browser cache.
          var url = previewUrl(link.getAttribute('data-strides-preview-language'));
          if (!url) {
            event.preventDefault();
            refresh();
            return;
          }
          link.href = url;
        });
        // Filters can change the URL after mount. Refresh before normal or context-menu navigation.
        group.addEventListener('focusin', function () { updateLinks(group); });
        group.addEventListener('pointerdown', function () { updateLinks(group); });
      }
      updateLinks(group);
      group.hidden = false;
    });
  }

  window.__stridesPreviewLanguages = { refresh: refresh };
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('popstate', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
}());
